import {
    IBackboneProduct,
} from '@ve/types/backboneModels/Domain/ObjectValue';
import { IReturnProductType } from '@ve/pages/hotel/types';
import _ from 'underscore';

export default (products: IBackboneProduct[], tourSearchModel: any) => {
    if (!products || !products.length) {
        return [];
    }
    return products.map((product) => ({
        startDate: tourSearchModel.getFromDate(product),
        price: product.get('product')?.get('priceWithOilTax') || product.get('product').get('price'),
        type: product.get('type'),
        meal: product.get('product')?.get('meal'),
        operator: _.pick(product.get('product').get('operator'), 'id', 'name'),
        nights: product.get('product').get('nights'),
        block: !!product.get('product')?.get('block'),
        isExclusive: product.get('isExclusive'),
    }));
};